module.exports = __webpack_public_path__ + "static/media/no-more-transactions.b3e5cb6e.svg";